import PaymentDetails from './Details';

export { PaymentDetails };
